import { trackUserEvent } from "@app-utilities/observability";
import { AppInsightsEvent } from "@app-utilities/observability-events";
import { h } from "vue";
import { RouteRecordRaw } from "vue-router";

import { home } from "./reservations";

export const maintenanceMode = "maintenance-mode";
export const bowlingMemories = "bowling-memories";
export const takePhoto = "take-photo";
export const payExtendYourPlay = "pay-eyp";

const baseRoutes: RouteRecordRaw[] = [
	{
		path: "/",
		name: "root",
		redirect: null as any
	},
	{
		path: "/:companyId(\\d{1,})",
		name: "root-company",
		redirect: null as any
	},
	{
		path: "/:companyId(\\d{1,})/:systemId(\\d{4,})",
		name: "root-company-system",
		redirect: { name: home }
	},
	{
		path: "/:companyId(\\d{1,})/:systemId(\\d{4,})/maintenance-mode",
		name: maintenanceMode,
		component: () => import("@app-views/maintenance-mode/maintenance-mode.vue")
	},
	{
		path: "/:companyId(\\d{1,})/:systemId(\\d{4,})/bowling-memories/:eventId(\\S+)",
		name: bowlingMemories,
		component: () => import("@app-views/bowling-memories/bowling-memories.vue"),
		meta: {
			isStandalonePage: true,
			showPhotoPrivacyAndTermsLink: true
		}
	},
	{
		path: "/:companyId(\\d{1,})/:systemId(\\d{4,})/take-photo/:eventId(\\S+)",
		name: takePhoto,
		component: () => import("@app-views/take-photo/take-photo.vue"),
		meta: {
			isStandalonePage: true
		}
	},
	{
		path: "/:companyId(\\d{1,})/:systemId(\\d{4,})/pay-eyp",
		name: payExtendYourPlay,
		component: { render: () => h("div") },
		meta: {
			isStandalonePage: true
		},
		beforeEnter: (to, _from, next) => {
			if (!to.query.q)
				throw new Error("Invalid query string");
			const base64Url = to.query.q.toString();
			trackUserEvent(AppInsightsEvent.SuperTouchExtendYourPlayQRScanned, {
				base64Url,
				CenterId: Number(to.params.systemId),
				CompanyId: Number(to.params.companyId)
			}, true);
			const urlDecoded = atob(base64Url);
			window.location.href = urlDecoded;
			next(false);
		}
	},
	{
		path: "/browser-not-supported",
		name: "browser-not-supported",
		component: () => import("@app-views/service/browser-not-supported.vue")
	},
	{
		path: "/disabled-features",
		name: "disabled-features",
		component: () => import("@app-views/service/disabled-features.vue")
	},
	{
		path: "/error",
		name: "error-page",
		component: () => import("@app-views/service/error/error.vue")
	}
];

export default baseRoutes;
